import { useEffect } from 'react';
import { useEventNotificationsEventId } from '../../../event-notifications/event-notifications-event-id-context';
import { useEventNotificationsStore } from '../../../event-notifications/use-event-notifications';
import { eventPanelTabConfigs, EventPanelTab } from './event-panel-tabs-config';

export function TabNotificationsDismisser(props: { tab: EventPanelTab }) {
    const eventNotificationsStore = useEventNotificationsStore();
    const eventNotificationsEventId = useEventNotificationsEventId();
    useEffect(() => {
        return () => {
            const tabConfig = eventPanelTabConfigs[props.tab];
            if ('notificationTypes' in tabConfig && eventNotificationsEventId) {
                eventNotificationsStore.removeNotifications({
                    eventId: eventNotificationsEventId,
                    entityId: eventNotificationsEventId,
                    notifications: tabConfig.notificationTypes ?? [],
                });
            }
            if ('notificationsEntityTypes' in tabConfig && eventNotificationsEventId) {
                tabConfig.notificationsEntityTypes?.forEach((notificationsEntityType) => {
                    eventNotificationsStore.removeAllNotificationsForEntityTypeForEvent(
                        eventNotificationsEventId,
                        notificationsEntityType
                    );
                });
            }
        };
    }, [props.tab, eventNotificationsStore, eventNotificationsEventId]);
    return null;
}
